import { onBeforeUnmount, onMounted } from 'vue'
import * as Sentry from '@sentry/vue'
import { isCancel } from 'axios'
import { HttpError } from '@/helpers/errors'

/**
 * Repeats a fetch the user did not ask for. Failures go to Telebugs instead of
 * the error toast, and nothing is sent while the browser is offline.
 */
export function useBackgroundPoll(
  fetch: () => Promise<unknown>,
  intervalMs: number
) {
  let interval: ReturnType<typeof setInterval> | null = null
  let inFlight = false

  async function poll() {
    if (!navigator.onLine || inFlight) {
      return
    }

    inFlight = true

    try {
      await fetch()
    } catch (err) {
      if (isCancel(err) || (err instanceof HttpError && err.isCanceled)) {
        return
      }

      Sentry.captureException(err)
    } finally {
      inFlight = false
    }
  }

  onMounted(() => {
    interval = setInterval(poll, intervalMs)
  })

  onBeforeUnmount(() => {
    if (interval) {
      clearInterval(interval)
    }
  })
}
